import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { PatientService } from '@service/patient.service';
import { FormControl, Validators, FormGroup, FormBuilder, FormGroupDirective, NgForm } from '@angular/forms';
import { PatientInsurance, PatientDetailMaster, PatientContact, Patient, InsuranceCase } from '@models/appointments/patient.model';
import { RoutingHelper } from '@helpers/routinghelper';
import { Router, ActivatedRoute } from '@angular/router';
import { BeyondEMRConstants } from '@helpers/beyondemrconstants';
import * as moment from 'moment';
import { ErrorStateMatcher } from '@angular/material/core';
import { DatePipe } from '@angular/common';
import { BeyondEMRHelper } from '@helpers/beyondemr-helper';
import { MatSelect } from '@angular/material/select';


export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const invalidCtrl = !!(control && control.invalid);
    const invalidParent = !!(control && control.parent && control.parent.invalid);

    return (invalidCtrl || invalidParent);
  }
}

@Component({
  selector: 'app-authorization-form-dialog',
  templateUrl: './authorization-form.component.html',
  styleUrls: ['./authorization-form.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthorizationFormComponent {
  public action: string;
  public dialogTitle: string;
  authorizationForm: FormGroup;
  patient: Patient;
  authorizationItem: InsuranceCase;
  masters: PatientDetailMaster;
  index: number;
  Aindex: number;
  isActive = false;
  disabled = false;
  isDisabled: boolean = false;
  responsible: '';
  file: any;
  files: Array<any> = new Array<any>();
  apiURL: string = '';
  dbName: string;
  beyondEMRConstants: any;
  CaseType: '';
  CaseTypeId: string = '';
  CaseRequired: boolean = false;
  caseTypeId: number;
  isCaseRequired: boolean = false;
  startDate: any;
  endDate: any;
  FromDate: any;
  ToDate: any;
  authorizationName: any;

  @ViewChild(MatSelect) matSelect: MatSelect;

  constructor(
    public dialogRef: MatDialogRef<AuthorizationFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public patientService: PatientService,
    private fb: FormBuilder,
    private router: Router,
    private datePipe?: DatePipe,
    private route?: ActivatedRoute,
    private helper?: BeyondEMRHelper,
    private routingHelper?: RoutingHelper,
  ) {
    // Set the defaults
    this.action = data.action;
    dialogRef.disableClose = true;
    this.beyondEMRConstants = BeyondEMRConstants;
    let id = this.routingHelper.GetRoutingParamerterId(this.route.params);
    this.masters = data.masters;
    this.bindMasters(id);

    if (this.action === 'edit') {
      this.dialogTitle = 'Edit Authorization';
      this.patient = data.patient;

      this.index = data.index;
      this.Aindex = data.Aindex;
      this.authorizationItem = this.patient.Insurance[this.index].Authorization[this.Aindex];
      this.index = data.index;
      this.CaseTypeId = this.filterByMaster(this.authorizationItem.CaseTypeId, this.masters?.CaseType);

      this.startDate = this.authorizationItem.StartDate ? new Date(this.authorizationItem.StartDate) : null;
      this.endDate = this.authorizationItem.EndDate ? new Date(this.authorizationItem.EndDate) : null;
      this.caseTypeId = this.authorizationItem.CaseTypeId;
      this.authorizationName = this.authorizationItem.InsuranceCaseName;
      this.isCaseRequired = this.authorizationItem.IsCaseRequired;
    }
    else {
      this.dialogTitle = 'Add Authorization';
      this.patient = data.patient;
      this.index = data.index;
      this.Aindex = data.Aindex;
      this.authorizationItem = new InsuranceCase();

    }

    this.authorizationForm = this.createForm();
    this.apiURL = data.apiURL;
    this.dbName = data.dbName;
  }

  formControl = new FormControl('', [
    Validators.required,
    // Validators.email,
  ]);

  getErrorMessage() {
    return this.formControl.hasError('required')
      ? 'Required field'
      : this.formControl.hasError('email')
        ? 'Not a valid email'
        : '';
  }

  createForm(): FormGroup {
    let FromDate: string = this.datePipe.transform(this.authorizationItem.StartDate, "MM/dd/yyyy")
    let ToDate: string = this.datePipe.transform(this.authorizationItem.EndDate, "MM/dd/yyyy")
    return this.fb.group({
      StartDate: [FromDate, this.authorizationItem.IsCaseRequired ? Validators.required : []],
      EndDate: [ToDate, this.authorizationItem.IsCaseRequired ? Validators.required : []],
      Id: [this.authorizationItem.Id, this.authorizationItem.IsCaseRequired ? Validators.required : []],
      InsuranceId: [this.authorizationItem.InsuranceId, this.authorizationItem.IsCaseRequired ? Validators.required : []],
      AuthorizationName: [this.authorizationItem.InsuranceCaseName, this.authorizationItem.IsCaseRequired ? Validators.required : []],
      CaseTypeId: [this.authorizationItem.CaseTypeId, this.authorizationItem.IsCaseRequired ? Validators.required : []],
      AuthNumber: [this.authorizationItem.AuthNumber, this.authorizationItem.IsCaseRequired ? Validators.required : []],
      NoOfUnits: [this.authorizationItem.NoOfUnits, this.authorizationItem.IsCaseRequired ? Validators.required : []],
      Name: [this.authorizationItem.Name, this.authorizationItem.IsCaseRequired ? Validators.required : []],
      PhoneNumber: [this.authorizationItem.PhoneNumber, this.authorizationItem.IsCaseRequired ? Validators.required : []],
      Notes: this.authorizationItem.Notes,
      PaymentMethodId: BeyondEMRConstants.PaymentMethod.Insurance,
      CaseRequired: this.authorizationItem.IsCaseRequired,
    }, { validator: this.checkDates });
  }

  updateCaseRequired() {
    this.authorizationItem.IsCaseRequired = this.isCaseRequired;
  }

  checkDates(group: FormGroup) {

    if ((group.controls.StartDate.value != null && group.controls.EndDate.value != null) && (group.controls.EndDate.value < group.controls.StartDate.value)) {
      group.controls.EndDate.setErrors({ EndDateLessThanStartDate: true });
      return { EndDateLessThanStartDate: true }
    }
    return null;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  public confirmAdd(): void {
    this.isDisabled = true;
    let authorization = this.authorizationForm.getRawValue();
    this.bindAuthorization(authorization);
    if (this.action === 'edit') {
      this.patient.Insurance[this.index].Authorization[this.Aindex] = this.authorizationItem;
    }
    else {
      this.patient.Insurance[this.index].Authorization.push(this.authorizationItem);
    }
    this.saveInsurance();
  }

  saveInsurance() {
    this.dialogRef.close(this.patient);
  }

  bindAuthorization(authorization) {
    this.authorizationItem.CaseTypeId = authorization.CaseTypeId;
    this.authorizationItem.StartDate = this.datePipe.transform(authorization.StartDate, BeyondEMRConstants.NewDateSaveFormat);
    this.authorizationItem.EndDate = this.datePipe.transform(authorization.EndDate, BeyondEMRConstants.NewDateSaveFormat);
    this.authorizationItem.AuthNumber = authorization.AuthNumber;
    this.authorizationItem.NoOfUnits = authorization.NoOfUnits;
    this.authorizationItem.InsuranceCaseName = authorization.AuthorizationName;
    this.authorizationItem.IsCaseRequired = authorization.CaseRequired;
    this.authorizationItem.Name = authorization.Name;
    this.authorizationItem.PhoneNumber = authorization.PhoneNumber;
    this.authorizationItem.Notes = authorization.Notes;
    this.authorizationItem.PaymentMethodId = authorization.PaymentMethodId;
  }

  filterByMaster(id, master): any {
    if (id > 0) {
      var result = master?.find(x => x.Id == id);
      return result ? result['Name'] : '';
    }
  }

  filterIdByMaster(name, master): any {
    if (name.value) {
      var result = master?.find(x => x.Name == name.value);
      return result ? result['Id'] : '';
    }
  }

  bindMasters(id) {
    let isCreate = id > 0 ? false : true;
    this.masters.CaseType = this.helper.bindMaster(this.masters.CaseType, isCreate, this.authorizationItem?.CaseTypeId);
  }

  ngAfterViewInit() {
    this.matSelect.openedChange.subscribe(opened => {
      if (opened) {
        this.matSelect.panel.nativeElement.addEventListener('mouseleave', () => {
          this.matSelect.close();
        })
      }
    })

  }

  ClearEndDate() {
    this.endDate = null;
    this.authorizationItem.EndDate = null;
  }
}
